import { buildQuickview } from "@coveo/headless";
import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import SelectBtn from "../Button/SelectBtn";
import AgreeBtn from "../Button/AgreeBtn";
import DownloadBtn from "../Button/DownloadBtn";
import DownloadInfo from "./DownloadInfo";

const InetDownload: FunctionComponent<any> = (props) => {
    // TODO: remove data_mock , currently data in small inet mock doesn't have EOS camera, i mock here to show enough 3 button
    // const EOS_WEBCAM_UTILITY_STR = "EOS Webcam Utility";
    let recommended = props.result.raw.recommended;
    const EOS_WEBCAM_UTILITY_STR = "EOS Webcam Utility";
    const fileName = props.result.raw.filename; // toDo inet
    const filetTitle = props.result.raw.title;
    const [downloadEnabled, setDownloadEnabled] = useState(false);
    //const fileDate = ''; // toDo inet
    // const isRecomended = props.result?.raw.recommended?.toLowerCase() == "recommended"; //toDo inet
    const fileSize: string | undefined = convertFileSizeToMB(props.result.raw.filesize); // in bytes , cal /1024**2  to get MB
    const linkDownload: string = props.result.raw.ineturl?.replace("http://", "https://");
    const cardContent = props.result.raw.inet_downloads_hierarchy ? props.result.raw.inet_downloads_hierarchy[0] : props.result.raw.commonsupportcontenttype;
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const convertDate = (date: any) => {
        let dateObj = new Date(date);
        let dateString: any = dateObj.toLocaleDateString("en-US");
        let dateArr = dateString.split("/");
        let day = dateArr[1] < 10 ? "0" + dateArr[1] : dateArr[1];
        let month = dateArr[0] < 10 ? "0" + dateArr[0] : dateArr[0];
        let year = dateArr[2];
        return month + "-" + day + "-" + year;
    }
    let postedDate = convertDate(props.result.raw.date);

    const BtnCTA: FunctionComponent<any> = function({props}) {

        if (props.result.raw.title.toLowerCase().includes(EOS_WEBCAM_UTILITY_STR.toLowerCase())) {
            return (<SelectBtn item={props.result.raw}></SelectBtn>);
        }
        if (props.result.raw.inetfiletype === 'FA') {
            return (<AgreeBtn item={props.result.raw}></AgreeBtn>);
        }
        return (<DownloadBtn item={props.result.raw}></DownloadBtn>);
    }

    function convertFileSizeToMB (fileSize: string) {
        if (!fileSize) {
            return;
        }
        let fileInfo = fileSize.split(' ');
        if (fileInfo.length < 2) {
            return fileSize;
        }
        let size: any = fileInfo[0].replace(",",'');

        if (fileInfo[1].toLowerCase() === "kb") {
            size = Math.round(size / (1024) * 100) / 100;
        } else if (fileInfo[1].toLowerCase() === "b") {
            size = Math.round(size / (1024**2) * 100) / 100;
        } else if (fileInfo[1].toLowerCase() === "gb") {
            size = Math.round(size * 1024 * 100) / 100;
        }
        return size + " MB";
    }

    function downloadFile (e: any) {
        e.preventDefault();
        let buttonElm = $(e.currentTarget).parents(".content").find(".cardDownloadMetaData");
        let buttonDownloadCheckbox = buttonElm.find(">.download__cta");
        let buttonSelect = buttonElm.find(">.select__cta");
        if (buttonDownloadCheckbox.length > 0 && buttonDownloadCheckbox.find(".cta-btn-container a.btn.disabled").length > 0) {
            return;
        }
        if (buttonSelect.length > 0 && !buttonSelect.hasClass("btn-selected-container")) {
            return;
        }
        let downloadButton = buttonElm.find(".outlined-btn-wrapper a");
        if (downloadButton.length > 0) {
            downloadButton[0].click()
        }
    }

    const handleCheckbox = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        let agreeCheckbox = event.currentTarget?.parentElement?.parentElement?.nextElementSibling?.querySelector(".cta-checkbox .checkbox") as HTMLElement; 
        let checked: boolean = event.currentTarget.getAttribute("aria-checked") === "true";
        if (checked) {
            event.currentTarget.classList.remove("selected");
        } else {
            event.currentTarget.classList.add("selected");
        }
        event.currentTarget.setAttribute("aria-checked", String(!checked));
        agreeCheckbox?.click();
    }

    const handleTermClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        let tcButton = event.currentTarget.parentElement?.parentElement?.parentElement?.nextElementSibling?.querySelector(".cta-checkbox .terms-conds-link") as HTMLElement;
        tcButton.click();
    }

    return (
        <div className="cardDiv cardDownload cardDownloadMobile general-support-card product-result-support">
            <div className="cardDescriptionDiv gs_cardDescriptionDiv">
                <div className="cardContentType">
                    <span className="cardContentSpan">{cardContent}</span>
                </div>
            <div className="content">
                <div className="row cardTitleDiv">
                    <div className="cardTitleSpan">
                        {props.isShowRecommendedForModel && recommended && recommended.includes(props.isShowRecommendedForModel) && (<span className="cardTitleRec cardContentspan">Recommended</span>)}
                        <span className="cardTitleContent" onClick={downloadFile}>{filetTitle}</span>
                    </div>
                    <div className="cardDate rightSection">
                        <span><strong>Date:</strong></span> <span>{postedDate}</span>
                    </div>
                </div>
                <div className="row cardDownloadLink">
                        <DownloadInfo item={props.result.raw} isShowRecommendedForModel={props.isShowRecommendedForModel}></DownloadInfo>
                    <div className="download-info">
                        <div className="rightSection cardDate">
                            <span><strong>Date:</strong></span> <span>{postedDate}</span>
                        </div>
                        <div className="rightSection fileSize">
                            <span><strong>File Size:</strong></span> <span>{fileSize}</span>
                        </div>
                    </div>
                    {(props.result.raw.inetfiletype === 'FA') && (
                        <div className="cta-checkbox">
                            <span onClick={handleCheckbox} role="checkbox" className={"checkbox ada-clickable" + (isSelected ? ' selected' : '')} aria-checked="false" aria-label="Terms and conditions"></span>
                            <span className="label">I agree to the <a className="terms-conds-link" onClick={handleTermClick} data-target="#termsConditionsModal">Terms&nbsp;&amp;&nbsp;Conditions</a></span>
                        </div>
                    )}
                </div>
                <div className="row cardDownloadMetaData">
                    <DownloadInfo item={props.result.raw} isShowRecommendedForModel={props.isShowRecommendedForModel}></DownloadInfo>
                    <BtnCTA props={props}></BtnCTA>
                </div>
                </div>
            </div>
        </div>
    )
};

export default InetDownload;
